module.exports = __webpack_public_path__ + "static/Frogsong6-45b0fb817ee81e73d65671bbbb4f4805.webp";